import enhance from './AddPoFormContainer';
import SharedPoForm from '../SharedPoForm';

export default enhance(SharedPoForm);
